import {
  CURRENCY_METADATA,
  formatCurrency,
  getCurrencyMetadata,
  getCurrencyOptions,
  type CurrencyMetadata,
  type FormatCurrencyOptions,
  type SupportedCurrency,
} from '@company/shared'
import { useCallback } from 'react'

// 系统固定使用 USDT 作为基础货币
const DEFAULT_CURRENCY: SupportedCurrency = 'USDT'
const DEFAULT_DECIMALS = 2

/**
 * 货币格式化 hook
 * 提供基于系统配置的货币格式化功能
 */
export function useCurrencyFormatter() {
  /**
   * 格式化货币金额
   * @param amount 金额（分）
   * @param currency 货币代码（可选，默认 USDT）
   * @param options 格式化选项
   */
  const format = useCallback(
    (amount: number, currency?: string, options?: FormatCurrencyOptions): string => {
      return formatCurrency(amount, currency ?? DEFAULT_CURRENCY, {
        decimals: DEFAULT_DECIMALS,
        ...options,
      })
    },
    []
  )

  /**
   * 格式化货币金额（简化版，用于替换旧的 formatMoney 函数）
   */
  const formatMoney = useCallback(
    (cents: number, currency?: string): string => {
      return format(cents, currency)
    },
    [format]
  )

  return {
    format,
    formatMoney,
    defaultCurrency: DEFAULT_CURRENCY,
    defaultDecimals: DEFAULT_DECIMALS,
    currencyOptions: getCurrencyOptions(),
    getCurrencyMetadata,
    CURRENCY_METADATA,
  }
}

/**
 * 导出类型
 */
export type { CurrencyMetadata, FormatCurrencyOptions, SupportedCurrency }
